<template>
    <transition name="modal">
        <div class="modal-mask" @click="close" v-if="show">
            <div class="modal-container" :class="[getSize, className]" @click.stop>
                <a class="closeButton closeBlack" @click="close">
                    <i class="fa fa-times" aria-hidden="true"></i>
                </a>
                <slot></slot>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
  name: 'Modal',
  props: ['show', 'className', 'size'],
  watch: {
    show: function (val) {
      if (val === true) {
        this.onShow()
      }
    }
  },
  computed: {
    getSize () {
      if (this.size === 'SMALL') {
        return 'modal-container-sm'
      } else if (this.size === 'LARGE') {
        return 'modal-container-lg'
      }
      return 'modal-container-md'
    }
  },
  methods: {
    close: function () {
      console.log('close')
      let self = this
      self.$emit('close')
    },
    onShow: function () {
    }
  },
  mounted: function () {
    document.addEventListener('keydown', (e) => {
      if (this.show && e.keyCode === 27) {
        this.$emit('close')
      }
    })
  }
}
</script>

<style scoped lang='scss'>

.text-right {
    text-align: right;
}

.form-label {
    display: block;
    margin-bottom: 1em;
}

.form-label > .form-control {
    margin-top: 0.5em;
}

.form-control {
    display: block;
    width: 100%;
    padding: 0.5em 1em;
    line-height: 1.5;
    border: 1px solid #ddd;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */
.closeButton{
    font-size:20px;
}
.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-container{
  overflow-y:scroll;
  position: absolute;
  top: 0;
}

@media only screen and (max-width: 480px) {
    .modal-container {
        padding-bottom: 200px;
    }
}

.modal-container-sm{
    max-width:450px;
}

.modal-container-lg{
  max-width:960px;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  transform: translateY(200%);
}
</style>



// WEBPACK FOOTER //
// src/components/models/Modal.vue